import { styled } from 'styled-system/jsx'

const TeaserCard = styled('button', {
  base: {
    width: '100%',
    backgroundColor: 'quickpass.surfaceCool',
    border: '1.5px solid',
    borderColor: 'quickpass.primarySoft',
    borderRadius: 'lg',
    padding: '14px 16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    textAlign: 'left',
    fontFamily: 'body',
    transition:
      'transform {durations.fast} {easings.appleStandard}, border-color {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _hover: {
      transform: 'translateY(-1px)',
      borderColor: 'quickpass.primary',
      boxShadow: '0 12px 28px -16px rgba(128, 84, 255, 0.3)',
    },
    _active: {
      transform: 'translateY(0)',
    },
  },
})

const Glyph = styled('span', {
  base: {
    width: '40px',
    height: '40px',
    borderRadius: 'pill',
    backgroundColor: '#FFFFFF',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    flexShrink: '0',
    boxShadow: '0 6px 14px -8px rgba(128, 84, 255, 0.25)',
  },
})

const Body = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    flex: '1',
    minWidth: '0',
  },
})

const Eyebrow = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: 'quickpass.primary',
  },
})

const HeadlineRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '10px',
    minWidth: '0',
  },
})

const Headline = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.ink',
    letterSpacing: '-0.1px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: '1',
    minWidth: '0',
  },
})

const Time = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    flexShrink: '0',
  },
})

const Body2 = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
})

const TrailingMeta = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexShrink: '0',
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.primary',
  },
})

const CountPill = styled('span', {
  base: {
    backgroundColor: 'quickpass.primary',
    color: '#FFFFFF',
    paddingX: '8px',
    paddingY: '2px',
    borderRadius: 'pill',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.3px',
  },
})

const Chevron = styled('span', {
  base: {
    fontSize: '16px',
    lineHeight: '1',
  },
})

export {
  TeaserCard,
  Glyph,
  Body,
  Eyebrow,
  HeadlineRow,
  Headline,
  Time,
  Body2,
  TrailingMeta,
  CountPill,
  Chevron,
}
